import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, EmptyState, Pagination, Spinner, PageHeader } from '@shared/ui';
import { ROUTES } from '@shared/config/routes';
import { useMyQuotesQuery } from '@entities/rfq';
import { QuotesTable } from '@features/quote-list';

export function QuotesPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const { data, isLoading, isError, error, refetch } = useMyQuotesQuery(page, 20);

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={t('quotes.title')} subtitle={t('quotes.subtitle')} />

      {isLoading ? (
        <div className="flex justify-center py-12">
          <Spinner />
        </div>
      ) : isError ? (
        <p>
          {t('quotes.loadFail', { message: error?.message ?? 'unknown' })}{' '}
          <button type="button" className="underline" onClick={() => void refetch()}>
            {t('common.retry')}
          </button>
        </p>
      ) : data && data.items.length === 0 ? (
        <EmptyState
          title={t('quotes.title')}
          description={t('quotes.subtitle')}
          action={<Button onClick={() => navigate(ROUTES.buyRequests)}>{t('buyRequests.title')}</Button>}
        />
      ) : data ? (
        <>
          <QuotesTable data={data.items} />
          <Pagination page={data.page} totalPages={data.totalPages} onPageChange={setPage} />
        </>
      ) : null}
    </div>
  );
}
